import { Entity, EntityRecord, PartialEntityRecord } from "@/orm/types";
import { DatePickerInput } from "@mantine/dates";
import { Timestamp } from "firebase/firestore";
import { useAtomValue } from "jotai";

export const Timestamps = <T extends EntityRecord = EntityRecord>({
  entity,
}: {
  entity: Entity<T>;
}) => {
  const { data: item } = useAtomValue(entity.getObserveEntityRecordAtom());

  return (
    <>
      <DatePickerInput
        label="Created"
        size="sm"
        value={item?.createdAt?.toDate()}
        onChange={(date) => {
          if (!date) return;
          entity.update({
            createdAt: Timestamp.fromDate(date),
          } as unknown as PartialEntityRecord<T>);
        }}
      />
      <DatePickerInput
        label="Last Updated"
        size="sm"
        value={item?.updatedAt?.toDate() || item?.createdAt?.toDate()}
        readOnly
        styles={{
          input: {
            cursor: "not-allowed",
            background: "transparent",
          },
        }}
      />
    </>
  );
};
